import React, { useState } from 'react';
import axios from 'axios';
import CommonApi from '../../Api/CommonApi';

export default function ImageUploader({
  onUploaded,
}: {
  onUploaded: (url: string) => void;
}) {
  const [uploading, setUploading] = useState(false);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    try {
      setUploading(true);
      const res = await CommonApi.addImageFile(formData);
      onUploaded(res.data.url);
    } catch (err) {
      console.error('Upload failed', err);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <input type='file' accept='image/*' onChange={handleFileChange} />
      {uploading && <p>Uploading...</p>}
    </div>
  );
}
